import { Box, Container, CssBaseline, ThemeProvider } from '@mui/material';
import React from 'react';
import theme from '../theme/theme';
import BuildInfo from './BuildInfo';
import Navigation from './Navigation';

export interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
      <Navigation />
        <Container
          maxWidth="xl"
          sx={{
            flexGrow: 1,
            py: 3,
            px: { xs: 2, sm: 3 },
          }}
        >
          {children}
        </Container>
        <Box
          component="footer"
          sx={{
            py: 2,
            px: 3,
            backgroundColor: 'primary.main',
            color: 'primary.contrastText',
            textAlign: 'center',
            mt: 'auto',
          }}
        >
          <Box sx={{ opacity: 0.8, fontSize: '0.875rem' }}>
            Family Archive - Preserving memories for generations
          </Box>
          <BuildInfo />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
